import React, { useImperativeHandle, forwardRef } from 'react';
import { KPIEditor } from '../LibraryPage/KPIEditor';
// @ts-ignore
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm, useFieldArray } from 'react-hook-form';
// @ts-ignore
import * as yup from 'yup';

export const KPIEditorProvider = forwardRef(
  (
    { kpis, groupOptions, typeOptions, onKPIEditorBlur, models, onSubmit }: any,
    ref,
  ) => {
    useImperativeHandle(ref, () => ({ submit }));
    const isKpiExist = (value: any) =>
      models.kpis.some((k: any) => k.name === value);

    const submit = (data: any) => handleSubmit(onSubmit)(data);
    const formSchema = {
      name: yup
        .string()
        .required('Please give the KPI a name')
        .test(
          'unique',
          'KPI already exists with this name, please choose another',
          (value: any) => !isKpiExist(value),
        ),
      group: yup
        .string()
        .nullable()
        .required('Please assign the KPI to a group'),
      type: yup.string().required('Please give the KPI a type'),
    };

    const fieldsSchema = yup.object().shape({
      kpiEditor: yup
        .array()
        .of(yup.object().shape(formSchema))
        .required('Must have fields')
        .min(1, 'Minimum of 1 field'),
    });

    const methods = useForm({
      //@ts-ignore
      resolver: yupResolver(fieldsSchema),
      shouldUnregister: false,
      defaultValues: {
        kpiEditor: [{ name: '' }],
      },
      mode: 'onBlur',
    });

    const { control, handleSubmit } = methods;
    const { fields, remove } = useFieldArray({
      control,
      name: 'kpiEditor',
    });

    return (
      <FormProvider {...methods}>
        {fields.map((kpi: any, index: number) => {
          return (
            // @ts-ignore
            <KPIEditor
              kpi={kpis}
              index={index}
              groupOptions={groupOptions}
              typeOptions={typeOptions}
              key={kpi.id}
              onChange={onKPIEditorBlur}
              onDelete={remove}
            />
          );
        })}
      </FormProvider>
    );
  },
);
